<header class="p-topbar">
  <a class="brand-chip" routerLink="/">
    <span class="logo-mark"><img src="brand/salutissima-mark.png" alt="" width="24" height="24" /></span>
    <span class="brand-copy">
      <strong>salutissima</strong>
      <small>Area riservata</small>
    </span>
  </a>

  <nav class="p-nav" aria-label="Navigazione area riservata">
    @for (item of nav; track item.route) {
      <a [routerLink]="item.route" routerLinkActive="is-active" [attr.aria-label]="item.label" [attr.title]="item.label"><app-icon [name]="item.icon" [size]="18" /><span class="p-nav__label">{{ item.label }}</span></a>
    }
  </nav>

  <div class="toolbar-actions">
    <a class="p-new" nz-button nzType="primary" nzSize="small" [routerLink]="nuovaPratica"><app-icon name="add" [size]="17" />Nuova pratica</a>
    <a class="topbar__icon-btn" [routerLink]="notifiche" aria-label="Notifiche"><app-icon name="notifications" /></a>
    @if (me(); as m) {
      <div class="user-chip">
        <span class="user-chip__avatar">{{ initials() }}</span>
        <span class="user-chip__copy">
          <strong>{{ m.nome }} {{ m.cognome }}</strong>
          <small>Socio</small>
        </span>
      </div>
    }
    <a class="p-account" [routerLink]="account" routerLinkActive="is-active" aria-label="Il mio account">
      <app-icon name="manage_accounts" [size]="18" /><span class="p-account__label">Il mio account</span>
    </a>
    <a class="topbar__icon-btn p-logout" [routerLink]="logout" aria-label="Esci"><app-icon name="logout" /></a>
  </div>
</header>

<main class="p-content">
  <router-outlet />
</main>

<nav class="p-bottom-nav" aria-label="Navigazione rapida">
  @for (item of nav; track item.route) {
    <a [routerLink]="item.route" routerLinkActive="is-active" [style.grid-column]="item.bottomSlot"><app-icon [name]="item.icon" [size]="22" />{{ item.shortLabel }}</a>
  }
  <a class="p-bottom-nav__new" [routerLink]="nuovaPratica" aria-label="Nuova pratica"><span class="p-fab"><app-icon name="add" [size]="26" /></span>Nuova</a>
</nav>
